export const CASES = {
    UPDATE_SHARED_SECTIONS: 'UPDATE_SHARED_SECTIONS',
    UPDATE_SHARED_SECTIONS_FORM: 'UPDATE_SHARED_SECTIONS_FORM',
    CLEAR_SHARED_SECTIONS: 'CLEAR_SHARED_SECTIONS',
};
